"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckMarkWrapper = exports.Step = exports.Stepper = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ = require("../");

var _helpers = require("../../helpers");

var _svgs = require("../../svgs");

var _Tabs = require("../Tabs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** Stepper */
var Stepper = function Stepper(props) {
  return _react.default.createElement(_.Tabs // This key is required to ensure the tab state updates with
  // the currentStepIndex change
  , _extends({
    key: props.currentStepIndex,
    separator: _react.default.createElement(ChevronWrapper, null, _react.default.createElement(_svgs.ChevronIcon, {
      fill: "black30",
      width: "12px"
    })),
    transformTabBtn: transformTabBtn
  }, props));
};

exports.Stepper = Stepper;
Stepper.displayName = "Stepper";

/** Step */
var Step = function Step(props) {
  return _react.default.createElement(_.Tab, props);
};

exports.Step = Step;
Step.displayName = "Step";

var DisabledStepButton = function DisabledStepButton(_ref) {
  var children = _ref.children;
  return _react.default.createElement(DisabledStepContainer, null, _react.default.createElement(_.Sans, {
    size: "3t",
    color: "black30"
  }, children));
};

DisabledStepButton.displayName = "DisabledStepButton";

var transformTabBtn = function transformTabBtn(element, tabIndex, props) {
  var currentStepIndex = props.currentStepIndex,
      _props$initialTabInde = props.initialTabIndex,
      initialTabIndex = _props$initialTabInde === void 0 ? 0 : _props$initialTabInde,
      disableNavigation = props.disableNavigation;
  var returnDisabledButton = disableNavigation && tabIndex !== initialTabIndex;

  var disabledButton = _react.default.createElement(DisabledStepButton, {
    key: tabIndex
  }, element.props.children); // Don't allow users to jump ahead


  if (tabIndex > currentStepIndex) {
    return disabledButton; // Step done
  } else if (currentStepIndex && tabIndex < currentStepIndex) {
    return _react.default.createElement(_.Flex, {
      key: tabIndex
    }, _react.default.createElement(CheckMarkWrapper, null, _react.default.createElement(_svgs.CheckIcon, {
      fill: "green100"
    })), returnDisabledButton && tabIndex !== initialTabIndex ? disabledButton : element, _react.default.createElement("div", null), " "); // Disabled
  } else if (returnDisabledButton) {
    return disabledButton; // Step
  } else {
    return element;
  }
};

var ChevronWrapper = _styledComponents.default.span.withConfig({
  displayName: "Stepper__ChevronWrapper",
  componentId: "asru8e-0"
})(["margin:0 ", "px;line-height:normal;"], (0, _helpers.space)(2));
/** CheckMarkWrapper */


var CheckMarkWrapper = _styledComponents.default.span.withConfig({
  displayName: "Stepper__CheckMarkWrapper",
  componentId: "asru8e-1"
})(["margin-right:", "px;line-height:normal;"], (0, _helpers.space)(1));

exports.CheckMarkWrapper = CheckMarkWrapper;

var DisabledStepContainer = _styledComponents.default.div.withConfig({
  displayName: "Stepper__DisabledStepContainer",
  componentId: "asru8e-2"
})(["", ";cursor:default;"], _Tabs.sharedTabsStyles.tabContainer);
//# sourceMappingURL=Stepper.js.map